module.exports = __webpack_public_path__ + "static/media/hockey-women.57746d64.mov";